// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"11":"month-of-statement","398":"appointment","425":"meter-reading","836":"consumption","922":"unsubscribe","962":"home"}[chunkId] || chunkId) + "-legacy." + {"11":"f8d5e3d8","273":"b34e1fa5","398":"c93f86a4","425":"b5af1dd4","511":"4c0d5f6e","836":"998eafc4","922":"edbb6bb1","962":"9a1cc57c"}[chunkId] + ".js";
};